import Backbone from 'backbone';
import Promise from 'bluebird';
import _ from 'underscore';

export const getAccountService = ({ state, jsdata, edm }) => {
  if (!state || !jsdata || !edm) {
    return {};
  }
  /**
   * Class representing a AccountService for HotelCenter
   * @extends Backbone.Model
   */
  class AccountService extends Backbone.Model {
    fetchSubAccountAsync() {
      const currentSubAccountId = state.get('subAccount_id');
      const subAccountModel = state.get('subAccount_model');

      if (subAccountModel && subAccountModel.Id === currentSubAccountId) {
        return new Promise((resolve) => {
          resolve(subAccountModel);
        });
      } else if (currentSubAccountId && currentSubAccountId !== '') {
        // if the subAccountId don't equal to current subAccountId
        // fetch the new result
        return this.fetchSubAccountById(currentSubAccountId);
      }

      // when all subaccounts is selcted ,subaccount Id will be ''
      state.unset('subAccount_model');
      return new Promise((resolve) => {
        resolve(_.noop());
      });
    }

    fetchSubAccountById(subAccountId) {
      return jsdata.SubAccount
        .find(subAccountId, {
          entitySet: edm.currentAccount.SubAccounts,
          cacheResponse: false,
          bypassCache: true,
        })
        .then((subAccount) => {
          if (subAccount) {
            state.set('subAccount_model', subAccount);
          }

          return state.get('subAccount_model');
        });
    }
  }
  return {
    AccountService,
  };
};
